import{defineCustomElement as f}from"./utils/defineCustomElement.js";import{Window as n,Document as g}from"./utils/server-safe-globals.js";import{MediaUIEvents as c,MediaUIAttributes as u,MediaStateChangeEvents as m}from"./constants.js";import{nouns as p}from"./labels/labels.js";import{containsComposedNode as E}from"./utils/element-utils.js";import"./media-gesture-receiver.js";const b=g.createElement("template");b.innerHTML=`
  <style>
    :host {
      box-sizing: border-box;
      position: relative;
      display: inline-block;
      line-height: 0;
      background-color: var(--media-background-color, #000);
    }

    :host(:not([audio])) [part~=layer]:not([part~=media-layer]) {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-flow: column nowrap;
      align-items: start;
      pointer-events: none;
      background: none;
    }

    /*
     * when in audio mode, hide the gesture-layer which causes media-controller to be taller than the control bar
     *
     */
    :host([audio]) [part~=layer][part~=gesture-layer] {
      height: 0;
      display: block;
    }

    /*
     * if gestures are disabled, don't accept pointer-events
     */
    :host(:not([audio])[gestures-disabled]) ::slotted([slot=gestures-chrome]),
    :host(:not([audio])[gestures-disabled]) media-gesture-receiver[slot=gestures-chrome] {
      pointer-events: none;
    }

    /*
     * any slotted element that isn't a poster or media slot should be pointer-events auto
     * we'll want to add here any slotted elements that shouldn't get pointer-events by default when slotted
     */
    ::slotted(:not([slot=media]):not([slot=poster]):not(media-loading-indicator)) {
      pointer-events: auto;
    }

    :host(:not([audio])) *[part~=layer][part~=centered-layer] {
      align-items: center;
      justify-content: center;
    }

    :host(:not([audio])) ::slotted(media-gesture-receiver[slot=gestures-chrome]),
    :host(:not([audio])) media-gesture-receiver[slot=gestures-chrome] {
      align-self: stretch;
      flex-grow: 1;
    }

    .spacer {
      pointer-events: none;
      background: none;
    }

    /* Position the media and poster elements to fill the container */
    ::slotted([slot=media]),
    ::slotted([slot=poster]) {
      width: 100%;
      height: 100%;
    }

    /* Video specific styles */
    :host(:not([audio])) .spacer {
      flex-grow: 1;
    }

    /* Safari needs this to actually make the element fill the window */
    :host(:-webkit-full-screen) {
      /* Needs to use !important otherwise easy to break */
      width: 100% !important;
      height: 100% !important;
    }

    /* Only add these if auto hide is not disabled */
    ::slotted(:not([slot=media]):not([no-auto-hide])) {
      opacity: 1;
      transition: opacity 0.25s;
    }

    /* Hide controls when inactive, not paused, not audio and auto hide not disabled */
    :host([user-inactive]:not([${u.MEDIA_PAUSED}]):not([${u.MEDIA_IS_CASTING}]):not([audio])) ::slotted(:not([slot=media]):not([no-auto-hide])) {
      opacity: 0;
      transition: opacity 1s;
    }

    ::slotted(media-control-bar)  {
      align-self: stretch;
    }
  </style>

  <span part="layer media-layer">
    <slot name="media"></slot>
  </span>
  <span part="layer poster-layer">
    <slot name="poster"></slot>
  </span>
  <span part="layer gesture-layer">
    <slot name="gestures-chrome">
      <media-gesture-receiver slot="gestures-chrome"></media-gesture-receiver>
    </slot>
  </span>
  <span part="layer vertical-layer">
    <slot name="top-chrome"></slot>
    <span class="spacer"><slot name="middle-chrome"></slot></span>
    <!-- default, effectively "bottom-chrome" -->
    <slot></slot>
  </span>
  <span part="layer centered-layer">
    <slot name="centered-chrome"></slot>
  </span>
`;const y=Object.values(u);class v extends n.HTMLElement{constructor(){super();this.attachShadow({mode:"open"}),this.shadowRoot.appendChild(b.content.cloneNode(!0));const e=i=>{const t=this.media;for(let l of i)l.type==="childList"&&(l.removedNodes.forEach(d=>{if(d.slot=="media"&&l.target==this){let r=l.previousSibling&&l.previousSibling.previousElementSibling;if(!r||!t)this.mediaUnsetCallback(d);else{let h=r.slot!=="media";for(;(r=r.previousSibling)!==null;)r.slot=="media"&&(h=!1);h&&this.mediaUnsetCallback(d)}}}),t&&l.addedNodes.forEach(d=>{d==t&&this.handleMediaUpdated(t).then(r=>this.mediaSetCallback(r))}))};new MutationObserver(e).observe(this,{childList:!0,subtree:!0});let s=this.media,o=this.querySelector(":scope > slot[slot=media]");o&&o.addEventListener("slotchange",()=>{if(!o.assignedElements({flatten:!0}).length){this.mediaUnsetCallback(s);return}this.media&&(s=this.media,this.handleMediaUpdated(this.media).then(t=>this.mediaSetCallback(t)))})}static get observedAttributes(){return["autohide","gestures-disabled"].concat(y)}attributeChangedCallback(e,a,s){e.toLowerCase()=="autohide"&&(this.autohide=s)}get media(){let e=this.querySelector(":scope > [slot=media]");return(e==null?void 0:e.nodeName)=="SLOT"&&(e=e.assignedElements({flatten:!0})[0]),e}mediaSetCallback(e){this._mediaClickPlayToggle=()=>{const a=e.paused?c.MEDIA_PLAY_REQUEST:c.MEDIA_PAUSE_REQUEST;this.dispatchEvent(new n.CustomEvent(a,{composed:!0,bubbles:!0}))}}handleMediaUpdated(e){const a=i=>Promise.resolve(i),s=i=>(console.error('<media-chrome>: Media element set with slot="media" does not appear to be compatible.',i),Promise.reject(i));if(!e)return s(e);const o=e.nodeName.toLowerCase();return o.includes("-")?n.customElements.whenDefined(o).then(()=>a(e)):a(e)}mediaUnsetCallback(){}connectedCallback(){const a=this.getAttribute("audio")!=null?p.AUDIO_PLAYER():p.VIDEO_PLAYER();this.setAttribute("role","region"),this.setAttribute("aria-label",a),this.media&&this.handleMediaUpdated(this.media).then(t=>this.mediaSetCallback(t)),this.setAttribute("user-inactive","user-inactive");const s=()=>{if(this.autohide<0)return;this.setAttribute("user-inactive","user-inactive");const t=new n.CustomEvent(m.USER_INACTIVE,{composed:!0,bubbles:!0,detail:!0});this.dispatchEvent(t)},o=()=>{this.removeAttribute("user-inactive");const t=new n.CustomEvent(m.USER_INACTIVE,{composed:!0,bubbles:!0,detail:!1});this.dispatchEvent(t)},i=()=>{o(),n.clearTimeout(this._inactiveTimeout),!(this.autohide<0)&&(this._inactiveTimeout=n.setTimeout(()=>{s()},this.autohide*1e3))};this.addEventListener("keyup",()=>{i()}),this.addEventListener("pointerup",t=>{t.pointerType==="touch"&&([this,this.media].includes(t.target)&&!this.hasAttribute("user-inactive")?s():i())}),this.addEventListener("pointermove",t=>{t.pointerType==="mouse"&&(!E(this,t.target)||(o(),n.clearTimeout(this._inactiveTimeout),[this,this.media].includes(t.target)&&i()))}),this.addEventListener("mouseleave",()=>{s()}),this.addEventListener("keyup",()=>{this.setAttribute("media-keyboard-control","")}),this.addEventListener("mouseup",()=>{this.removeAttribute("media-keyboard-control")})}set autohide(e){e=Number(e),this._autohide=isNaN(e)?0:e}get autohide(){return this._autohide===void 0?2:this._autohide}}f("media-container-temp",v);var T=v;export{T as default};
//# sourceMappingURL=media-container.js.map
